export const COMPANY_SENDING_REQUEST = "COMPANY_SENDING_REQUEST"
export const COMPANY_DETAIL_SUCCESS = "COMPANY_DETAIL_SUCCESS"
export const COMPANY_REQUEST_FAIL = "COMPANY_REQUEST_FAIL"
